import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

/**
 * Ambil nilai field berdasarkan bahasa aktif.
 * Jika field bahasa Inggris tidak tersedia, fallback ke field Indonesia.
 * Contoh: pick(item, 'judul') → item.judul_en || item.judul (ketika lang=en)
 */
export const pickLang = (obj, field, lang) => {
  if (!obj) return "";
  if (lang === "en") {
    return obj[`${field}_en`] || obj[field] || "";
  }
  return obj[field] || "";
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") || "id",
  );

  const toggleLanguage = () => {
    const next = language === "id" ? "en" : "id";
    setLanguage(next);
    localStorage.setItem("lang", next);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, pickLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
